/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ProfileIcon.vue?vue&type=template&id=4bceff1c"
import script from "./ProfileIcon.vue?vue&type=script&lang=js"
export * from "./ProfileIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bceff1c')) {
      api.createRecord('4bceff1c', component.options)
    } else {
      api.reload('4bceff1c', component.options)
    }
    module.hot.accept("./ProfileIcon.vue?vue&type=template&id=4bceff1c", function () {
      api.rerender('4bceff1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/ProfileIcon.vue"
export default component.exports